/* ==========================================================================
   Riddle Rovers · Studio layer — "Ogni pagina nasconde un indizio"
   Decorative enhancements on top of the existing sections. Nothing here is
   needed to read, choose or buy: it starts after the page has loaded, uses
   transform / opacity only, pauses off-screen and respects reduced motion.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__rrStudio) return;
  window.__rrStudio = true;

  var d = document, html = d.documentElement;
  var me = d.currentScript;
  var mq = function (q) { return window.matchMedia ? window.matchMedia(q).matches : false; };
  var REDUCE = mq('(prefers-reduced-motion: reduce)');
  var FINE = mq('(hover: hover) and (pointer: fine)');
  var MOBILE = mq('(max-width: 749px)');
  var conn = navigator.connection || {};
  var LOW = !!conn.saveData || ((navigator.hardwareConcurrency || 8) <= 4 && (navigator.deviceMemory || 8) <= 4);
  if (window.Shopify && window.Shopify.designMode) return; // keep the theme editor calm

  var T = { rover: 'Rover was here!', code: 'R · O · V · E · R', secretBtn: "Rover left a coded message", secretAria: "Decode Rover's secret message", secretMsg: "Rover's secret message: thanks for exploring all the way down here. Your next clue is waiting in your printer! 🐾" };
  try { var j = d.getElementById('rrs-i18n'); if (j) { var o = JSON.parse(j.textContent); for (var k in o) if (o[k]) T[k] = o[k]; } } catch (e) {}

  var PAW = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 13.2c-2.9 0-5.6 2.7-5.6 5.1 0 1.7 1.3 2.5 2.9 2.5 1.1 0 1.8-.5 2.7-.5s1.6.5 2.7.5c1.6 0 2.9-.8 2.9-2.5 0-2.4-2.7-5.1-5.6-5.1z"/><ellipse cx="6.2" cy="10.4" rx="1.9" ry="2.4"/><ellipse cx="9.6" cy="6.6" rx="2" ry="2.6"/><ellipse cx="14.4" cy="6.6" rx="2" ry="2.6"/><ellipse cx="17.8" cy="10.4" rx="1.9" ry="2.4"/></svg>';
  var GLYPHS = '◆▲●■✦◇△○□✧#?%&§';

  function el(tag, cls, htmlStr) { var n = d.createElement(tag); if (cls) n.className = cls; if (htmlStr) n.innerHTML = htmlStr; return n; }
  function $$(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }
  function rnd(a, b) { return a + Math.random() * (b - a); }
  function lum(c) { var m = (c || '').match(/[\d.]+/g); if (!m || m.length < 3) return 0; return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; }
  function relHost(n) { if (getComputedStyle(n).position === 'static') n.classList.add('rrs-host'); }
  // a section's own positioned box when it has one, so no existing layout is touched
  function boxOf(sec) {
    var c = sec.firstElementChild;
    if (c && getComputedStyle(c).position !== 'static' && c.offsetHeight > sec.offsetHeight * 0.8) return c;
    relHost(sec); return sec;
  }
  function inView(n) { var r = n.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight; }
  function idle(fn, t) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: t || 1500 }); else setTimeout(fn, 200); }
  var IO = 'IntersectionObserver' in window;
  function once(n, fn, thr) {
    if (!IO) { fn(); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); fn(); } }); }, { threshold: thr || 0.25 });
    io.observe(n);
  }
  function session(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* ------------------------------------------------------------------
     1. Cipher kickers — small labels above titles decode into words
     ------------------------------------------------------------------ */
  function encode(node) {
    var text = node.textContent;
    if (!text || node.children.length || text.trim().length < 3 || text.length > 60) return null;
    var color = getComputedStyle(node).color;
    var wrap = el('span', 'rrs-dc');
    var spans = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text.charAt(i), s = el('span');
      if (ch.trim()) { s.className = 'is-enc'; var b = el('b'); b.setAttribute('aria-hidden', 'true'); b.textContent = GLYPHS.charAt((Math.random() * GLYPHS.length) | 0); s.appendChild(b); spans.push(s); }
      s.appendChild(d.createTextNode(ch));
      wrap.appendChild(s);
    }
    node.style.setProperty('--rrs-dc-c', color);
    node.textContent = '';
    node.appendChild(wrap);
    return { node: node, text: text, spans: spans };
  }
  function decode(job, dur) {
    dur = dur || 720;
    var n = job.spans.length, t0 = 0, last = 0;
    var at = job.spans.map(function (_, i) { return 120 + (i / Math.max(1, n - 1)) * (dur - 160) + rnd(-40, 40); });
    function frame(ts) {
      if (!t0) t0 = ts;
      var t = ts - t0, shuffle = ts - last > 55;
      if (shuffle) last = ts;
      var left = 0;
      job.spans.forEach(function (s, i) {
        if (!s.classList.contains('is-enc')) return;
        if (t >= at[i]) { s.classList.remove('is-enc'); var b = s.firstChild; if (b && b.tagName === 'B') s.removeChild(b); }
        else { left++; if (shuffle) s.firstChild.textContent = GLYPHS.charAt((Math.random() * GLYPHS.length) | 0); }
      });
      if (left) requestAnimationFrame(frame); else job.node.textContent = job.text; // back to plain text
    }
    requestAnimationFrame(frame);
  }
  function kickers() {
    $$('.adv-eyebrow, .adventure-eyebrow, .rr-tag, .rr-gt-k, .rr-smp-k, .adv-banner__kicker').forEach(function (n) {
      if (n.closest('header, .advh, .advc, .advp, [data-adv-cart], .rrs-secret')) return;
      if (inView(n) || !IO) return; // never change text the visitor is already reading
      // encode just before it scrolls in (so the text stays plain for crawlers and audits), decode once it is visible
      var pre = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        pre.disconnect();
        var job = encode(n);
        if (job) once(n, function () { decode(job); }, 0.6);
      }, { rootMargin: '0px 0px 30% 0px' });
      pre.observe(n);
    });
  }

  /* ------------------------------------------------------------------
     1b. Highlighter strokes under the accent words of big titles
     ------------------------------------------------------------------ */
  function marks() {
    $$('.rr-lp h1 > span, .rr-lp h2 > span, .rr-lp h2 > em').forEach(function (n) {
      if (n.className || n.children.length || n.textContent.trim().length < 3) return;
      n.classList.add('rrs-mark');
      once(n, function () { n.classList.add('is-on'); }, 0.8);
    });
  }

  /* ------------------------------------------------------------------
     2. Paw-print trail stamped at the top of each section
     ------------------------------------------------------------------ */
  function trails() {
    var secs = $$('main > .shopify-section').slice(1);
    var foot = d.querySelector('.shopify-section-group-footer-group');
    if (foot) secs.push(foot);
    secs.forEach(function (sec, idx) {
      if (sec.offsetHeight < 180) return;
      if (MOBILE && sec.querySelector('#rr-reviews')) return; // keep the review stars clean on phones
      var box = boxOf(sec);
      var side = idx % 2 ? 'r' : 'l';
      var t = el('div', 'rrs-trail rrs-trail--' + side);
      t.setAttribute('aria-hidden', 'true');
      var ref = sec.querySelector('h2, h1, h3, p') || sec;
      t.style.setProperty('--rrs-trail', lum(getComputedStyle(ref).color) > 0.6 ? '#f6c445' : '#f47c2c');
      var count = MOBILE ? 5 : 6, stepX = MOBILE ? 30 : 40;
      for (var i = 0; i < count; i++) {
        var p = el('i', '', PAW);
        p.style.left = (i * stepX) + 'px';
        p.style.top = ((i % 2 ? (MOBILE ? 14 : 18) : 0) + (count - i) * 3) + 'px';
        p.style.setProperty('--i', i);
        p.style.setProperty('--r', (82 + rnd(-6, 6)).toFixed(0) + 'deg');
        p.style.setProperty('--o', (0.3 + i * 0.05).toFixed(3));
        t.appendChild(p);
      }
      box.appendChild(t);
      once(t, function () { t.classList.add('is-in'); }, 0.9);
    });
  }

  /* ------------------------------------------------------------------
     3. Living covers — 3D tilt + glare (mouse), shine sweep (touch)
     ------------------------------------------------------------------ */
  function covers() {
    $$('.adventure-worlds__cover, .adv-cg__media, .adventure-collection-grid .adventure-card__media, .adventure-collection-grid__media').forEach(function (c) {
      if (c.__rrs) return; c.__rrs = 1;
      relHost(c);
      var g = el('span', 'rrs-glare'); g.setAttribute('aria-hidden', 'true'); c.appendChild(g);
      if (FINE) {
        c.classList.add('rrs-tilt');
        var raf = 0, ev = null;
        var apply = function () {
          raf = 0; if (!ev) return;
          var r = c.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width - 0.5, py = (ev.clientY - r.top) / r.height - 0.5;
          c.style.setProperty('--ry', (px * 9).toFixed(2) + 'deg');
          c.style.setProperty('--rx', (py * -9).toFixed(2) + 'deg');
          c.style.setProperty('--gx', (px * 50).toFixed(1) + '%');
          c.style.setProperty('--gy', (py * 50).toFixed(1) + '%');
        };
        c.addEventListener('pointerenter', function () { c.classList.add('is-tilting'); });
        c.addEventListener('pointermove', function (e) { ev = e; if (!raf) raf = requestAnimationFrame(apply); }, { passive: true });
        c.addEventListener('pointerleave', function () { ev = null; c.classList.remove('is-tilting'); c.style.setProperty('--rx', '0deg'); c.style.setProperty('--ry', '0deg'); });
      } else {
        once(c, function () { c.classList.add('rrs-shine'); }, 0.6);
      }
    });
  }

  /* ------------------------------------------------------------------
     4. UV torch — the signature: a violet light that reveals invisible ink
     ------------------------------------------------------------------ */
  function inkHTML() {
    var paws = '';
    for (var i = 0; i < 6; i++) paws += '<span class="rrs-ink rrs-ink--paw" style="left:' + (6 + i * 6.5) + '%;top:' + (84 - i * 6 - (i % 2) * 3) + '%;transform:rotate(' + (52 + (i % 2) * 14) + 'deg)">' + PAW + '</span>';
    return paws +
      '<span class="rrs-ink rrs-ink--msg" style="left:10%;top:34%">' + T.rover.replace(/</g, '&lt;') + '</span>' +
      '<span class="rrs-ink rrs-ink--arrow" style="left:44%;top:56%"><svg viewBox="0 0 110 48"><path d="M4 30c22-24 54-30 86-14" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-dasharray="2 9"/><path d="M84 6l18 12-20 9" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
      '<span class="rrs-ink rrs-ink--x" style="left:72%;top:70%"><svg viewBox="0 0 46 46"><path d="M8 8l30 30M38 8L8 38" fill="none" stroke="currentColor" stroke-width="6" stroke-linecap="round"/></svg></span>' +
      '<span class="rrs-ink rrs-ink--q" style="left:78%;top:14%"><svg viewBox="0 0 54 54"><circle cx="27" cy="27" r="23" fill="none" stroke="currentColor" stroke-width="3.5" stroke-dasharray="5 6"/><path d="M20 21c0-4.5 3.4-7.5 7.3-7.5 4.1 0 7.2 2.7 7.2 6.6 0 5.4-6.6 5.8-6.6 11" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><circle cx="27.9" cy="38.5" r="2.6"/></svg></span>' +
      '<span class="rrs-ink rrs-ink--code" style="left:48%;top:88%">' + T.code.replace(/</g, '&lt;') + '</span>';
  }
  function torch(host, key, evt) {
    if (!host || host.__rrsUv) return; host.__rrsUv = 1;
    evt = evt || host;
    relHost(host);
    var wrap = el('div', 'rrs-uv'); wrap.setAttribute('aria-hidden', 'true');
    var lens = el('div', 'rrs-uv__lens'), ink = el('div', 'rrs-uv__ink', inkHTML());
    lens.appendChild(ink); wrap.appendChild(lens); host.appendChild(wrap);
    var W = 0, H = 0, L = 200, x = -999, y = -999, tx = x, ty = y, raf = 0, hovering = false, sweeping = false, hideT = 0;
    function size() {
      var r = host.getBoundingClientRect(); W = r.width; H = r.height;
      L = Math.round(Math.max(150, Math.min(MOBILE ? 200 : 300, Math.min(W, H) * (MOBILE ? 0.62 : 0.52))));
      wrap.style.setProperty('--rrs-l', L + 'px');
      ink.style.width = W + 'px'; ink.style.height = H + 'px';
    }
    function cl(v, max) { return max > L ? Math.max(L / 2, Math.min(max - L / 2, v)) : max / 2; }
    function paint() {
      var cx = cl(x, W), cy = cl(y, H); // keep the whole lens inside its area, never cut by the edges
      lens.style.transform = 'translate3d(' + (cx - L / 2).toFixed(1) + 'px,' + (cy - L / 2).toFixed(1) + 'px,0)';
      ink.style.transform = 'translate3d(' + (L / 2 - cx).toFixed(1) + 'px,' + (L / 2 - cy).toFixed(1) + 'px,0)';
    }
    function loop() {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2; paint();
      raf = (Math.abs(tx - x) + Math.abs(ty - y) > 0.4) ? requestAnimationFrame(loop) : 0;
    }
    function aim(nx, ny, jump) { tx = nx; ty = ny; if (jump) { x = tx; y = ty; paint(); } else if (!raf) raf = requestAnimationFrame(loop); }
    function show(v) { wrap.classList.toggle('is-on', v); }
    function local(e) { var r = host.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; }
    size();
    window.addEventListener('resize', size, { passive: true });
    function inside(p) { return p[0] >= 0 && p[1] >= 0 && p[0] <= W && p[1] <= H; }
    function leave() { hovering = false; if (!sweeping) show(false); }
    if (FINE) {
      evt.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || sweeping) return;
        var p = local(e);
        if (!inside(p)) { if (hovering) leave(); return; }
        if (!hovering) { hovering = true; aim(p[0], p[1], true); show(true); } else aim(p[0], p[1]);
      }, { passive: true });
      evt.addEventListener('pointerleave', leave);
    }
    evt.addEventListener('touchstart', function (e) {
      if (sweeping || !e.touches[0]) return;
      var p = local(e.touches[0]); if (!inside(p)) return;
      clearTimeout(hideT); aim(p[0], p[1], true); show(true);
    }, { passive: true });
    evt.addEventListener('touchmove', function (e) { if (!sweeping && e.touches[0] && wrap.classList.contains('is-on')) { var p = local(e.touches[0]); aim(p[0], p[1]); } }, { passive: true });
    evt.addEventListener('touchend', function () { clearTimeout(hideT); hideT = setTimeout(function () { show(false); }, 650); }, { passive: true });

    // a single demonstration sweep, the first time the visitor sees it in this session
    var skey = 'rrs-uv-' + key;
    if (session(skey)) return;
    once(host, function () {
      setTimeout(function () {
        if (hovering) return;
        session(skey, '1'); size(); sweeping = true;
        var dur = MOBILE ? 2600 : 3000, t0 = 0;
        aim(W * 0.12, H * 0.6, true); show(true);
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / dur), e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
          x = tx = W * (0.12 + 0.76 * e); y = ty = H * (0.55 + 0.22 * Math.sin(e * Math.PI * 2.2) - 0.18 * e); paint();
          if (p < 1) requestAnimationFrame(step);
          else { sweeping = false; if (!hovering) setTimeout(function () { if (!hovering) show(false); }, 350); }
        }
        requestAnimationFrame(step);
      }, 450);
    }, 0.55);
  }
  function torches() {
    var hero = d.querySelector('.adventure-hero');
    if (hero) {
      if (MOBILE) torch(hero.querySelector('.adventure-media'), 'home');
      else { relHost(hero); var zone = el('div', 'rrs-uvzone'); hero.appendChild(zone); torch(zone, 'home', hero); }
    }
    var stage = d.querySelector('.rr7-hero .rr-stage');
    if (stage) torch(stage, 'cc');
  }

  /* ------------------------------------------------------------------
     5. World atmospheres — light CSS particles in the first section
     ------------------------------------------------------------------ */
  var WORLDS = {
    'adventure-ninja': ['petal', 14], 'adventure-jurassic': ['leaf', 12], 'adventure-pyramid': ['dust', 16],
    'adventure-captain': ['bubble', 12], 'adventure-starhollow': ['star', 16], 'adventure-wanderwood': ['fly', 14],
    'adventure-hollow': ['bat', 7], 'adventure-bundle': ['spark', 12], 'index': ['dust', 14], 'adventure': ['spark', 10]
  };
  function atmosphere() {
    var w = WORLDS[html.getAttribute('data-rrs-world') || ''];
    var host = d.querySelector('main > .shopify-section');
    if (!w || !host) return;
    var type = w[0], n = Math.round(w[1] * (MOBILE ? 0.6 : 1) * (LOW ? 0.5 : 1));
    host = boxOf(host);
    var box = el('div', 'rrs-atmo'); box.setAttribute('aria-hidden', 'true');
    var colors = ['#ffd15c', '#ff8a3d', '#7c5cff', '#2bb3a3', '#ff6fa8'];
    var r = host.getBoundingClientRect();
    box.style.setProperty('--h', Math.round(r.height) + 'px');
    box.style.setProperty('--w', Math.round(r.width) + 'px');
    for (var i = 0; i < n; i++) {
      var p = el('i', 'rrs-p rrs-p--' + type), dur = 0;
      if (type === 'petal' || type === 'leaf') dur = rnd(9, 16);
      else if (type === 'dust' || type === 'bubble') dur = rnd(8, 15);
      else if (type === 'star' || type === 'spark') dur = rnd(3.5, 7);
      else if (type === 'fly') dur = rnd(7, 12);
      else dur = rnd(11, 18);
      p.style.setProperty('--x', (type === 'bat' ? 0 : rnd(2, 98)).toFixed(1) + '%');
      p.style.setProperty('--d', dur.toFixed(2) + 's');
      p.style.setProperty('--dl', (-rnd(0, dur)).toFixed(2) + 's');
      p.style.setProperty('--dx', rnd(-60, 60).toFixed(0) + 'px');
      p.style.setProperty('--y', rnd(r.height * 0.08, r.height * 0.85).toFixed(0) + 'px');
      p.style.setProperty('--s', rnd(0.6, 1.25).toFixed(2));
      p.style.setProperty('--o', rnd(0.45, 0.9).toFixed(2));
      if (type === 'spark') p.style.setProperty('--c', colors[i % colors.length]);
      box.appendChild(p);
    }
    host.appendChild(box);
    if (IO) new IntersectionObserver(function (es) { box.classList.toggle('is-paused', !es[0].isIntersecting); }).observe(host);
  }

  /* ------------------------------------------------------------------
     6. "Missione accettata!" — paper confetti from add-to-cart buttons
     ------------------------------------------------------------------ */
  var lastBurst = 0;
  function burst(btn) {
    if (!btn || !btn.getBoundingClientRect) return;
    var now = Date.now(); if (now - lastBurst < 700) return; lastBurst = now;
    var r = btn.getBoundingClientRect(); if (!r.width) return;
    var box = el('div', 'rrs-burst'); box.setAttribute('aria-hidden', 'true');
    box.style.transform = 'translate3d(' + (r.left + r.width / 2) + 'px,' + (r.top + r.height / 2) + 'px,0)';
    var cs = ['#f47c2c', '#f6c445', '#123b4a', '#7c5cff', '#2bb3a3', '#ff6fa8'];
    var n = MOBILE ? 16 : 22;
    for (var i = 0; i < n; i++) {
      var paw = i < 2, p = el('i', paw ? 'p' : '', paw ? PAW : '');
      var a = rnd(0, Math.PI * 2), dist = rnd(60, MOBILE ? 130 : 170);
      p.style.setProperty('--tx', (Math.cos(a) * dist).toFixed(0) + 'px');
      p.style.setProperty('--ty', (Math.sin(a) * dist * 0.75 - rnd(20, 70)).toFixed(0) + 'px');
      p.style.setProperty('--rot', rnd(-540, 540).toFixed(0) + 'deg');
      p.style.setProperty('--c', cs[i % cs.length]);
      p.style.setProperty('--sz', rnd(6, 11).toFixed(1) + 'px');
      p.style.setProperty('--ar', rnd(0.45, 1).toFixed(2));
      p.style.setProperty('--br', Math.random() > 0.6 ? '50%' : '2px');
      p.style.setProperty('--d', rnd(700, 1050).toFixed(0) + 'ms');
      box.appendChild(p);
    }
    d.body.appendChild(box);
    setTimeout(function () { box.remove(); }, 1200);
  }
  function celebrate() {
    // window + capture: runs before the cart drawer script, which stops the event at document level
    window.addEventListener('submit', function (e) {
      var f = e.target; if (!f || !f.getAttribute) return;
      if ((f.getAttribute('action') || '').indexOf('/cart/add') < 0) return;
      burst(e.submitter || f.querySelector('[type="submit"]'));
    }, true);
    window.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-buy], [data-buy-hhm], [data-advh-add], [data-advc-upgrade], [data-advc-trio-add], .shopify-payment-button__button');
      if (b) burst(b);
    }, true);
  }

  /* ------------------------------------------------------------------
     7. Rover's secret — a coded line at the very bottom of the footer
     ------------------------------------------------------------------ */
  function secret() {
    var bottom = d.querySelector('.advf-bottom');
    if (!bottom) return;
    var wrap = el('div', 'rrs-secret-wrap');
    var btn = el('button', 'rrs-secret');
    btn.type = 'button';
    var glyphs = ''; for (var i = 0; i < 18; i++) glyphs += GLYPHS.charAt((Math.random() * GLYPHS.length) | 0) + (i % 4 === 3 ? ' ' : '');
    btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10 2a8 8 0 0 1 6.3 12.9l5.4 5.4-1.4 1.4-5.4-5.4A8 8 0 1 1 10 2zm0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></svg><span>' + T.secretBtn + '<i aria-hidden="true" style="font-style:normal">: ' + glyphs + '</i></span>';
    btn.title = T.secretAria;
    wrap.appendChild(btn);
    bottom.parentNode.insertBefore(wrap, bottom.nextSibling);
    btn.addEventListener('click', function () {
      if (btn.__done) return; btn.__done = 1;
      btn.removeAttribute('title');
      var span = btn.querySelector('span');
      span.textContent = T.secretMsg;
      btn.setAttribute('aria-live', 'polite');
      if (!REDUCE) { var job = encode(span); if (job) decode(job, 1400); }
      burst(btn);
    });
  }

  /* ------------------------------------------------------------------
     boot: after the page has loaded and the browser is idle
     ------------------------------------------------------------------ */
  function boot() {
    var css = me && me.getAttribute('data-css');
    // one small job per idle slot, so the main thread never gets a long task
    // UV torch and Rover's secret footer button removed on Nico's request (20/10)
    var q = REDUCE ? [] : [celebrate, atmosphere, marks, kickers, trails, covers];
    if (d.documentElement.getAttribute('data-rrs-world') === 'adventure-bundle') q = REDUCE ? [] : [celebrate]; // the bundle page has its own art direction (rr8)
    var go = function pump(dl) {
      if (!q.length) return;
      do { var job = q.shift(); try { job(); } catch (e) {} }
      while (q.length && dl && dl.timeRemaining && dl.timeRemaining() > 12);
      if (q.length) idle(pump, 900);
    };
    if (!css) { go(); return; }
    var l = d.createElement('link'); l.rel = 'stylesheet'; l.href = css;
    l.onload = function () { idle(go, 800); };
    d.head.appendChild(l);
  }
  var started = false;
  function start() { if (started) return; started = true; idle(boot, 1200); }
  if (d.readyState === 'complete') start();
  else { window.addEventListener('load', start); setTimeout(start, 6000); }
})();
